import { useState } from 'react';

type TMode = 'expanded' | 'collapsed';

const KEY = 'hp.sidebar';
// The editor starts collapsed for the canvas; a toggle there holds for the tab, not for ever.
const EDITOR_KEY = 'hp.sidebar.editor';

const read = (storage: Storage, key: string, fallback: TMode): TMode => {
  const value = storage.getItem(key);
  return value === 'expanded' || value === 'collapsed' ? value : fallback;
};

export const useSidebarMode = (inEditor: boolean) => {
  const [everywhere, setEverywhere] = useState<TMode>(() => read(localStorage, KEY, 'expanded'));
  const [editor, setEditor] = useState<TMode>(() => read(sessionStorage, EDITOR_KEY, 'collapsed'));
  const collapsed = (inEditor ? editor : everywhere) === 'collapsed';

  const toggle = () => {
    const next: TMode = collapsed ? 'expanded' : 'collapsed';
    if (inEditor) {
      setEditor(next);
      sessionStorage.setItem(EDITOR_KEY, next);
    } else {
      setEverywhere(next);
      localStorage.setItem(KEY, next);
    }
  };

  return { collapsed, toggle };
};
